import React, { useState, useEffect, FC } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useAuth } from '../../auth/core/Auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ProfileDetails } from '../../accounts/components/settings/cards/ProfileDetails';

const API_URL_REAL = process.env.REACT_APP_API_URL



export const UploadId: FC = () => {
    const { logout, currentUser, setCurrentUser } = useAuth();
    const intl = useIntl();
    const navigate = useNavigate();

    useEffect(() => {
        if (currentUser?.tryosAttended === "-1") {
            navigate('/exam/tryos');
        } else if (currentUser?.surveyCompleted === "-1") {
            navigate('/exam/survey');
        } else if (currentUser?.idUploaded === "1") {
            // idUploaded durumunda yapılacak işlemler
            navigate('/auth');
        }
    }, []);




    return (
        <div>
            <ProfileDetails />
            <div className='card-footer d-flex justify-content-end py-6 px-9'>
                <Button variant='danger' onClick={logout}>
                    {intl.formatMessage({ id: 'Logout' })}
                </Button>
            </div>
        </div>
    );
};
